import * as Yup from "yup";

export const initialValues = {
  startDate: null,
  startTime: "00:00:00",
  endTime: "00:00:00",
  description: null,
};

const CollectTimeSchema = Yup.object().shape({
  startDate: Yup.string().required("Please select."),
  description: Yup.string().required("Please enter."),
});

export default CollectTimeSchema;
